// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { fnApply, isFunction } from "@nevware21/ts-utils";
import { STR_EMPTY } from "../../../constants/InternalConstants";
import { setProtoTypeName } from "../../../utils/HelperFuncs";
import { startActiveSpan } from "./utils";
/**
 * @internal
 * Create a tracer implementation.
 * @param host - The ApplicationInsights core instance
 * @returns A tracer object
 */
export function _createTracer(host, name) {
    var tracer = setProtoTypeName({
        startSpan: function (spanName, options) {
            // Note: context is not used / needed for Application Insights / 1DS
            if (host) {
                return host.startSpan(spanName, options);
            }
            return null;
        },
        startActiveSpan: function (name, fnOrOptions, fn) {
            // Figure out which parameter order was passed
            var theFn = null;
            var opts = null;
            if (isFunction(fnOrOptions)) {
                // startActiveSpan<F extends (span: IReadableSpan) => unknown>(name: string, fn: F): ReturnType<F>;
                theFn = fnOrOptions;
            }
            else {
                // startActiveSpan<F extends (span: IReadableSpan) => unknown>(name: string, options: IOTelSpanOptions, fn: F): ReturnType<F>; or
                opts = fnOrOptions;
                theFn = fn;
            }
            if (theFn) {
                return startActiveSpan(host, name, opts, function (spanScope) {
                    return fnApply(theFn, spanScope, [spanScope.span, spanScope]);
                });
            }
        }
    }, "OTelTracer" + (name ? (" (" + name + ")") : STR_EMPTY));
    return tracer;
}
//# sourceMappingURL=tracer.js.map